import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, SupplierProduct, TmsWebBaseEditCreateService } from 'tms-lib';
import { SupplierProductDetails } from '../../../models';
import { SupplierProductsForSupplier } from '../../../../purchasing/supplier/models';

@Injectable({
  providedIn: 'root',
})
export class SupplierProductService extends TmsWebBaseEditCreateService<
  SupplierProductDetails,
  SupplierProductDetails
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SupplierProduct', $localize`Supplier Products`, httpService, notificationService);
  }

  getForProduct(id: string): Observable<SupplierProduct[]> {
    return this.httpService.get<SupplierProduct[]>(`${this.apiUrl}/Product/${id}`);
  }

  getForSupplier(id: string): Observable<SupplierProductsForSupplier[]> {
    return this.httpService.get<SupplierProductsForSupplier[]>(`${this.apiUrl}/SupplierProducts/${id}`);
  }

  getForStockEnquiryProduct(id: string): Observable<SupplierProduct[]> {
    return this.httpService.get<SupplierProduct[]>(`${this.apiUrl}/StockEnquiryProduct/${id}`);
  }
}
